import { remoteConfigAdapter } from '@/adapters/remoteConfig';
import { createRemoteConfigStore } from '@/stores/createRemoteConfigStore';

const useRemoteConfigStore = createRemoteConfigStore({ remoteConfig: remoteConfigAdapter });

export { useRemoteConfigStore };
